<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form enctype="multipart/form-data">
          <div class="my-5"></div>
          <div class="row justify-content-center" v-for="document in documentTypes" :key="document.id">
            <div class="col-sm-7">
              <div class="form-group" > <!-- :class="{ 'form-group--error': $v.documentMap.$error }" -->
                <label>{{document.name}}</label>
                <span v-if="!isDisabilityDocument(document)">
                  (Preferentemente adjuntar DNI)<br>
                </span>

                <span  >
                  <input
                    style=""
                    type="file"
                    ref="file"
                    accept="application/pdf, image/jpeg, image/jpg, image/png"
                    @change="onFilePicked($event, document)"
                    :multiple="document.multiple_files"
                    :required="isRequiredDocument(document)"
                    :key="fileInputKey"
                  >
                  <!--  <button class="" @click="$refs.file.click()">open file dialog</button> -->
                </span>
                <div style="padding-top:10px" v-if="isRequiredDocument(document)"><i>*Es obligatorio adjuntar un archivo</i></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import FileInput from "vue-simple-file-input";
import { mapGetters } from "vuex";

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      documentTypes : [],
      fileInputKey : 0,
      hasDisabilityChanged : false,
      item: {
        documentMap : {},
        requiredCount : 0,
      }
    };
  },
  components: {
    FileInput,
  },
  validations: {
    item: {
      requiredCount: {
        isZero: (val) => val === 0,
        $autoDirty: true
      }
    }
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          // Formulario válido
          this.$store.commit("setStepFourData", this.item.documentMap);
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
    currentStep() {
      if(!this.$v.$invalid) {
        this.$emit("can-continue", { value: true });
      }
      if (this.hasDisabilityChanged) {
        this.hasDisabilityChanged = false;
        this.resetForm();
      }
    },
    hasDisability() {
      this.hasDisabilityChanged = true;
    }
  },
  created () {
    this.getDocumentTypes();
  },
  computed: {
    ...mapGetters(['getAspirantData']),
    hasDisability() {
      return this.getAspirantData[0].hasDisability;
    }
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$store.commit("setStepFourData", this.item.documentMap);
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods : {
    isRequiredDocument(documentType){
      return documentType.required || documentType.code === 'discapacidad_obligatorio';
    },
    isDisabilityDocument(documentType){
      return ['discapacidad', 'discapacidad_obligatorio'].includes(documentType.code);
    },
    countRequiredDocuments(){
      this.documentTypes.forEach(document => {
        const isRequired = this.isRequiredDocument(document);
        const key = document.id;

        this.item.documentMap[key] = [];
        if (isRequired) {
          this.item.requiredCount++;
        }
      });
      this.item.documentMap = newDocumentMap;
    },
    getDocumentTypes(){
      this.documentTypes = this.$route.params.call.documentTypes;
      if (!this.hasDisability) {
        this.documentTypes = this.documentTypes.filter(document => !this.isDisabilityDocument(document));
      }
      this.countRequiredDocuments();
    },
    resetForm(){
      this.documentTypes = null;
      this.item.documentMap = {};
      this.item.requiredCount = 0;
      this.fileInputKey++;

      this.getDocumentTypes();
    },
    clearDocumentFiles(isRequired, key) {
      this.item.documentMap[key] = [];
      if (isRequired) {
        this.item.requiredCount++;
      }
    },
    handleFileUpload(files, isRequired, key) {
      const hasFiles = this.item.documentMap[key].length

      if (isRequired && !hasFiles) {
          this.item.requiredCount--;
        }

      this.item.documentMap[key] = [];

      files.forEach(file => {
          const fr = new FileReader ();
          fr.readAsDataURL(file);
          fr.addEventListener('load', () => {
            this.item.documentMap[key].push(file);
          });
        })
    },
    onFilePicked (event, document) {
      const files = event.target.files || event.dataTransfer.files;
			const isRequired = this.isRequiredDocument(document);
      const key = document.id;

      if (files.length) {
        this.handleFileUpload(files, isRequired, key);
      } else {
        this.clearDocumentFiles(isRequired, key);
      }
    }
  }
};
</script>
<style>

.btn-file {
    position: relative;
    overflow: hidden;
}
.btn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    background: white;
    cursor: inherit;
    display: block;
}
</style>